import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker and listen for updates.
// When a new version is available, dispatch a custom event so UpdatePrompt can show a modal.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const event = new CustomEvent('pwaUpdateAvailable', { detail: { registration } });
    window.dispatchEvent(event);
  },
});
